import {httpGet,httpPost,httpPostPayload,httpJsonp,httpDelete} from '../../../api/base'
import config from '../../../config/config'

	//接口调用的统一方法书写
export default{
	getCorpInfo(params){
		return httpGet(config.default_domin+'api/fe/v1/j/saas/search/corpInfo',params)
	},
	getOrderDetail(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/welfare/personal/detail',params)
	},
	getOrderTrack(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/api/shipping/details',params)
	},
	getUserDetail(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/welfare/personal/personInfo',params)
	},
	getMyWelfare(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/welfare/list',params)
	},
	getMyCards(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/cares/message/list',params)
	},
	getMyActity(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/home/activity/list',params)
	},
	getAddress(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/welfare/address/list',params)
	},
	editAddress(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/welfare/address/doUpd',params)
	},
	addAddress(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/welfare/address/doAdd',params)
	},
	delAddress(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/welfare/address/doDel',params)
	},
	updateDefaultAddress(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/welfare/address/doUpdIsDefault',params)
	},
	getIsShowMergeNav(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v3/private/j/home/bottomMenuStatus',params,cb)
	},
	// switchCompany(params,cb){
	// 	return httpJsonp(config.cas_domin+'/api/v2/accessToken/switchCorp',params,cb)
	// },
	switchCompany(params,cb){
		return httpGet(config.agh_cas_domin+'/backend/api/fe/v1/private/j/switchCorp',params,cb)
	},
	sessionCheck(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v1/private/sessionCheck',params,cb)
	},
	getUserinfo(params,cb){
		return httpGet(config.m_api_domain+'api/fe/v1/private/p/Tools/getUserinfo',params,cb)
	},
	//生日场景接口   
	birthdayWishDel(params,cb){
		return httpDelete(config.default_domin+'backend/api/fe/v3/private/j/birthday/wish',params);
	},
	birthdayWishAdd(params,cb){
		return httpPost(config.default_domin+'backend/api/fe/v3/private/j/birthday/wish',params);
	},
	birthdayWishReplyDel(params,cb){
		return httpDelete(config.default_domin+'backend/api/fe/v3/private/j/birthday/wishReply',params);
	},
	birthdayWishReplyAdd(params,cb){
		return httpPost(config.default_domin+'backend/api/fe/v3/private/j/birthday/wishReply',params);
	},
	birthdayWishList(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v3/private/j/birthday/wish/list',params)
	},
	birthdayWishImageList(params,cb){
		return httpGet(config.default_domin+'backend/api/fe/v3/private/j/birthday/wish/replyImagesList',params)
	},
	birthdayAllList(params){
		return httpGet(config.default_domin+'backend/api/fe/v3/private/j/birthday/user/month',params)
    },
    birthdaySearchList(params){
		return httpGet(config.default_domin+'backend/api/fe/v3/private/j/birthday/user/list',params)
    },
	getUserList(params){
		return httpGet(config.default_domin+'backend/api/fe/v3/private/j/birthday/user/search',params)
    },
	birthdayWeekList(params){
		return httpGet(config.default_domin+'backend/api/fe/v3/private/j/birthday/user/weekFromEs',params)
	},
	birthdayWeekTotal() {
		return httpGet(config.default_domin+'backend/api/fe/v1/private/v3/home/weekBirthdayUserCount')
	},
	birthdayWishDetail(params){
		return httpGet(config.default_domin+'backend/api/fe/v3/private/j/birthday/wish/wishDetail',params)
	},
	birthdayPersonInfo(params){
		return httpGet(config.default_domin+'backend/api/fe/v3/private/j/birthday/wish/personHome',params)
	},
	birthdayCheckUserGuide(params){
		return httpGet(config.default_domin+'backend/api/fe/v3/private/j/birthday/user/checkUserGuide',params)
	},
	birthdayCaresWelfare(params){
		return httpGet(config.default_domin+'backend/api/fe/v3/private/j/birthday/user/caresWelfare',params)
	},
	//部门列表
	departmentList(params){
		return httpGet(config.default_domin+'backend/api/fe/v3/private/j/birthday/user/department',params)
	},
	//生日墙
	getToken(params,cb){
        return httpJsonp(config.b_api_domain+'api/fe/v1/private/p/Qiniu/getToken',params,cb)
	},
	// 获取祝福墙信息
	getWishWallInfo (params) {
		return httpGet(config.default_domin+'backend/api/fe/v1/private/j/wall',params)
	},
	//获取过生日人列表
	getBirthdayNum (params) {
		return httpGet(config.default_domin+'backend/api/fe/v1/private/j/wall/user',params)
	},
	// 获取祝福列表
	getWishList (params) {
		return httpGet(config.default_domin+'backend/api/fe/v1/private/j/wall/wish',params)
	},
	// 提交祝福
	addBoardWish(params) {
		return httpPost(config.default_domin+'backend/api/fe/v1/private/j/wall/wish',params)
	},
	// 获取用户信息
	userInfo(params) {
		return httpGet(config.default_domin+'backend/api/fe/v3/j/private/user/profile',params)
    },
    
    getCorpCustomize(params){
        return httpGet(config.apps_domain+'/api/fe/v1/private/p/corpCustomize/general',params)
    }
}